import siteContent from '../data/content';
import './WorkCard.css';

/**
 * Карточка проекта. Если у проекта есть внешний адрес, вся карточка
 * становится ссылкой.
 *
 * @param {object} props
 * @param {{ title: string, summary: string, tags?: string[], url?: string }} props.project
 */
function WorkCard({ project }) {
  const copy = siteContent.workCard;
  const content = (
    <>
      {project.tags?.length > 0 && (
        <div className="work__tags">
          {project.tags.map((tag) => (
            <span className="work__tag" key={tag}>
              {tag}
            </span>
          ))}
        </div>
      )}
      <h3 className="work__title">{project.title}</h3>
      <p className="work__summary">{project.summary}</p>
      <span className="work__link">
        {project.url ? copy.openProject : copy.details}
        <span className="work__arrow" aria-hidden="true">
          →
        </span>
      </span>
    </>
  );

  if (!project.url) {
    return <div className="work edge-hover">{content}</div>;
  }

  return (
    <a
      className="work edge-hover"
      href={project.url}
      target="_blank"
      rel="noreferrer noopener"
      aria-label={copy.openInNewTab(project.title)}
    >
      {content}
    </a>
  );
}

export default WorkCard;
